import { render } from "./ProductSelection.vue?vue&type=template&id=1037e1ae&scoped=true"
import script from "./ProductSelection.vue?vue&type=script&lang=ts"
export * from "./ProductSelection.vue?vue&type=script&lang=ts"

import "./ProductSelection.vue?vue&type=style&index=0&id=1037e1ae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1037e1ae"

export default script